import { useMutation } from '@apollo/client';
import { CREATE_ACTIVITY } from 'lib/api/mutations';

const useRequestCreateActivity = (options = {}) => {
  const [requestCreateActivity, mutationResult] = useMutation(CREATE_ACTIVITY, {
    fetchPolicy: 'no-cache', // this ensures update will only be called once for mutation
    ...options,
  });

  return [requestCreateActivity, mutationResult];
};

export { useRequestCreateActivity };
